<template>
  <form @submit.prevent="submit">
      <v-row>
          <v-col>
              <v-text-field
                  v-model="name"
                  :error-messages="nameErrors"
                  outlined
                  label="Full Name"
                  required
              ></v-text-field>
          </v-col>
          <v-col>
              <v-text-field
                  v-model="phone"
                  :error-messages="phoneErrors"
                  outlined
                  label="Phone No"
                  required
              ></v-text-field>
          </v-col>
      </v-row>

      <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          outlined
          label="Email"
          required
      ></v-text-field>

      <v-text-field
          v-model="address"
          :error-messages="addressErrors"
          outlined
          label="Address"
          required
      ></v-text-field>

      <v-text-field
          v-model="carName"
          :error-messages="carNameErrors"
          outlined
          label="Car's Name"
          required
      ></v-text-field>

      <v-text-field
          v-model="carPlate"
          :error-messages="carPlateErrors"
          outlined
          label="Car's Plate No"
          required
      ></v-text-field>

      <v-row>
          <v-col cols="6">
              <v-text-field
                  v-model="password"
                  :error-messages="passwordErrors"
                  outlined
                  label="Password"
                  required
                  type="password"
              ></v-text-field>
          </v-col>
          <v-col cols="6">
              <v-text-field
                  v-model="confirmPassword"
                  :error-messages="confirmPasswordErrors"
                  outlined
                  label="Confirm Password"
                  required
                  type="password"
              ></v-text-field>
          </v-col>
      </v-row>

      <v-btn class="mr-4" @click="submit" color="primary">
          Submit
      </v-btn>
      <p class="text-center py-5">Already Have an Account? <strong> <router-link 
            v-for="(item, index) in details" 
            :key="index" 
            :to="item.routeName" 
            class="text-decoration-none">{{ item.name }}</router-link></strong></p>
  </form>
</template>

<script>
import axios from 'axios';
export default {
  name: 'FormComponent',
  data() {
      return {
        details: [
      { name: 'Sign In', routeName: '/login' },],
          name: '',
          phone: '',
          email: '',
          address: '',
          carName: '',
          carPlate: '',
          password: '',
          confirmPassword: '',
          nameErrors: [],
          phoneErrors: [],
          emailErrors: [],
          addressErrors: [],
          carNameErrors: [],
          carPlateErrors: [],
          passwordErrors: [],
          confirmPasswordErrors: []
      };
  },
  methods: {
      validate() {
         
          this.nameErrors = [];
          this.phoneErrors = [];
          this.emailErrors = [];
          this.addressErrors = [];
          this.carNameErrors = [];
          this.carPlateErrors = [];
          this.passwordErrors = [];
          this.confirmPasswordErrors = [];

         
          if (!this.name) this.nameErrors.push("Name is required.");
          if (!this.phone) this.phoneErrors.push("Phone number is required.");
          if (!this.email) this.emailErrors.push("Email is required.");
          if (!this.address) this.addressErrors.push("Address is required.");
          if (!this.carName) this.carNameErrors.push("Car name is required.");
          if (!this.carPlate) this.carPlateErrors.push("Car plate number is required.");
          if (!this.password) this.passwordErrors.push("Password is required.");
          if (this.password !== this.confirmPassword) {
              this.confirmPasswordErrors.push("Passwords must match.");
          }

          return !(this.nameErrors.length || this.phoneErrors.length || this.emailErrors.length ||
this.addressErrors.length || 
                    this.carNameErrors.length || this.carPlateErrors.length || 
                    this.passwordErrors.length || this.confirmPasswordErrors.length);
      },
      async submit() {
          if (this.validate()) {
              this.isLoading = true;
              try {
                  const response = await axios.post('http://192.168.1.144:8000/register', {
                      name: this.name,
                      phone: this.phone,
                      email: this.email,
                      address: this.address,
                      carName: this.carName,
                      carPlate: this.carPlate,
                      password: this.password
                  });
                  alert('registered Successfull',response.data);
                  this.resetForm();
              } catch (error) {
                  console.error(error);
                  alert("An error occurred. Please try again.");
              } finally {
                  this.isLoading = false;
              }
          }
    },
    resetForm() {
      this.name = '';
      this.phone = '';
      this.email = '';
      this.address = '';
      this.carName = '';
      this.carPlate = '';
      this.password = '';
      this.confirmPassword = '';
      this.nameErrors = [];
      this.phoneErrors = [];
      this.emailErrors = [];
      this.addressErrors = [];
      this.carNameErrors = [];
      this.carPlateErrors = [];
      this.passwordErrors = [];
      this.confirmPasswordErrors = [];
    }
  }
};
</script>

<style scoped>

</style>
